import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
	withMobileDialog,
	Dialog,
	withStyles,
	DialogActions,
	DialogContent,
	TextField,
} from '@material-ui/core'
import { toggleGroupDialog, createGroup } from 'actions/contacts/groups'
import Button from 'components/theme/Button'

export default withRouter(
	connect(
		(state) => ({
			groupDialogOpen: state.addOrEditContact.groupDialogOpen,
		}),
		(dispatch) =>
			bindActionCreators({ toggleGroupDialog, createGroup }, dispatch),
	)(
		withStyles((theme) => ({
			rounded: {
				borderRadius: 28,
				overflowY: 'hidden',
				// height: '100%',
				[theme.breakpoints.down('sm')]: {
					borderRadius: 0,
					overflowY: 'auto',
				},
			},
		}))(
			withMobileDialog()(
				({
					fullScreen, // toggleTaskModal,
					groupDialogOpen,
					classes,
					toggleGroupDialog,
					createGroup,
					thenFunc,
				}) => {
					const [value, changeValue] = useState('')

					return (
						<Dialog
							fullWidth
							maxWidth="sm"
							fullScreen={fullScreen}
							open={Boolean(groupDialogOpen)}
							onClose={() => toggleGroupDialog(false)}
							aria-labelledby="responsive-dialog-title"
							// disableBackdropClick
							// disableEscapeKeyDown
							PaperProps={{ classes: { rounded: classes.rounded } }}
						>
							<DialogContent>
								<p
									style={{
										color: 'rgba(0, 0, 0, 0.87)',
										fontSize: '1.5rem',
										fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
										fontWeight: '400',
										lineHeight: '1.33',
										letterSpacing: '0em',
									}}
								>
									What should we call this group?
								</p>
								<TextField
									value={value}
									style={{ marginBottom: '10px', width: '100%' }}
									onChange={(e) => changeValue(e?.target?.value)}
									placeholder="Enter a group name"
								/>
							</DialogContent>
							<DialogActions>
								<Button
									disabled={!value}
									onClick={() => {
										createGroup(value).then((payload) => {
											if (thenFunc) {
												thenFunc(payload)
											}
										})
										toggleGroupDialog(false)
									}}
									color="primary"
								>
									Create
								</Button>
								<Button
									onClick={() => {
										toggleGroupDialog(false)
									}}
									color="primary"
								>
									Cancel
								</Button>
							</DialogActions>
						</Dialog>
					)
				},
			),
		),
	),
)
